<template>
  <div class="home"
       v-loading="loading">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="box">
      <div class="currency_box">
        <div class="kc_list font24"
             @click="toCourseList">课程列表</div>
        <div class="top_nav_list">
          <div class="top_nav_item"
               v-for="(item,index) in breadcrumbList"
               :key="index">{{item.name}}</div>
        </div>
      </div>
    </div>
    <!--              :style="{'background': activeIndex == index?'red':'','color':activeIndex == index?'#333':'#fff'}" -->
    <div :class="topShow?'topF tab_list':'tab_list'">
      <div class="currency_box">
        <div :class=" activeIndex == index?'tab_items font32':'tab_item font32'"
             @click="tabItem(index)"
             v-for="(item,index) in tab_list"
             :key="index">{{item.name}}</div>
      </div>
    </div>
    <div class="currency_box">
      <el-image style="width:100%"
                :src="tab_list[activeIndex].url"></el-image>
      <!-- <div v-else>1</div> -->
    </div>
    <div class="menu_box">
      <div class="currency_box btn_box">
        <div class="i">
          <img src="../../../assets/er.png"
               alt="">
        </div>
        <div class="btn font28"
             @click="toConfirm">{{tab_list[activeIndex].btnText}}</div>
      </div>
    </div>
    <!-- <div></div> -->
  </div>
</template>

<script>
import { resourceList } from '@/api/api.js'
export default {
  components: {},
  data () {
    return {
      topShow: false,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      breadcrumbList: [
        { name: '会员卡详情' }
      ],
      topShow: false,
      imgList: [],
      tab_list: [
        { name: '线上商学院', btnText: '申请线上商学院', url: '' },
        { name: '线上训练营年卡', btnText: '申请线上训练营年卡', url: '' },
        { name: '个人年度会员', btnText: '开通商学会员', url: '' },
      ],
      activeIndex: 0,
      data: {
        showIndex: 22,
        pageNumber: 1,
        pageSize: 100,
      }

    }
  },
  created () {
    if (this.$route.query.index) {
      this.activeIndex = this.$route.query.index;
    }
    this.getresourceList(22)
    this.getresourceList(23)
    this.getresourceList(24)
  },
  filters: {

  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  methods: {
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if (scrollTop > 170) {
        this.topShow = true
      } else {
        this.topShow = false
      }
    },
    async getresourceList (type) {  //获取资源
      this.data.showIndex = type
      const res = await resourceList(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      // if (type == 22) {
      this.$nextTick(() => {
        this.tab_list[type - 22].url = res.data[0].resourceUrl
      })
      // } else if (type == 23) {
      //   this.$nextTick(() => {
      //     this.imgList[1] = res.data[0].resourceUrl
      //   })
      // } else if (type == 24) {
      //   this.$nextTick(() => {
      //     this.imgList[2] = res.data[0].resourceUrl
      //   })
      // }

    },
    async getCardList () {
      const res = await platformVip('member_level')
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.list = res.data;
    },
    toConfirm () {
      if (this.activeIndex == 2) {
        if (!localStorage.getItem('accessToken')) {
          this.$refs.topNav.login()
          return
        }
        this.$router.push('/Confirm?type=card')
      } else {
        var type = 15
        if (this.$route.query.type == 'cur') {
          type = 15
        } else {
          type = 17
        }
        this.$router.push('/Form?type=' + type + '&miniType=' + this.activeIndex)
      }
    },
    toCourseList () {
      this.$router.push('/Screen')
    },
    tabItem (index) {
      console.log(index)
      this.activeIndex = index;
      // console.log(this.activeIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
  .menu_box {
    // background-color: #f5f5f5;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    margin-top: 50px;
    z-index: 1;
    background-color: #f2eee8;
    .btn_box {
      background-color: #f2eee8;
      // border-radius: 10px;

      i {
        padding-left: 20px;
        flex: 1;
      }
      .btn {
        height: 100%;
        width: 260px;
        text-align: center;
        background: #494949;
        color: #f9d7b1;
        // border-radius: 0 10px;
        line-height: 60px;
        cursor: pointer;
      }
    }
  }
  // padding-top: 30px;
  .box {
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #de1f26;
    color: #fff;
    .kc_list {
      font-weight: bold;
      padding-right: 18px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
    .top_nav_list {
      flex: 1;
      display: flex;
      padding-left: 30px;
      justify-content: flex-start;
      .top_nav_item {
        margin-right: 15px;
      }
    }
  }
  .topF {
    z-index: 1;
    position: fixed;
    top: 22px;
    left: 0;
    // background-color: #f5f5f5;
    // width: 100%;
    // height: 60px;
    // margin-top: 50px;
  }

  .tab_list {
    width: 100%;
    padding: 50px 0 38px 0;
    box-sizing: border-box;
    .tab_items {
      flex: 1;
      padding: 14px 0;
      text-align: center;
      background: #eabe6f;
      color: #000;
      cursor: pointer;
    }
    .tab_item {
      flex: 1;
      padding: 14px 0;
      text-align: center;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
